import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import PropTypes from "prop-types";

import IconButton from "../../../../packages/IconButton";
import WPHeading from "../../../../packages/WPHeading";

import { LICENSE_SORT_DIRECTION } from "../../../../constants/LicenseManagement.constants";

import { SortIcon } from "../../../../assets/icons";

const LicenseUserHeaderRenderer = ({
  displayName,
  sortDirection,
  onSortClick,
  id,
}) => {
  const { t } = useTranslation();

  const nextDirection =
    sortDirection === LICENSE_SORT_DIRECTION.ASC
      ? LICENSE_SORT_DIRECTION.DESC
      : LICENSE_SORT_DIRECTION.ASC;

  const handleSortClick = useCallback(() => {
    onSortClick?.({ sortBy: "name", sortDirection: nextDirection });
  }, [onSortClick, nextDirection]);

  const white = "var(--du-color-white)";
  const sortArrowFillConfig = {
    [LICENSE_SORT_DIRECTION.ASC]: { upFill: white, downFill: "none" },
    [LICENSE_SORT_DIRECTION.DESC]: { upFill: "none", downFill: white },
    default: { upFill: "none", downFill: "none" },
  };

  const sortIconProps = useMemo(() => {
    const { upFill, downFill } =
      sortArrowFillConfig[sortDirection] || sortArrowFillConfig.default;
    return {
      upColor: white,
      downColor: white,
      upFill,
      downFill,
    };
  }, [sortDirection]);

  const sortIcon = (
    <SortIcon
      style={{
        "--sort-up-color": sortIconProps.upColor,
        "--sort-down-color": sortIconProps.downColor,
        "--sort-up-fill": sortIconProps.upFill,
        "--sort-down-fill": sortIconProps.downFill,
      }}
    />
  );

  return (
    <div className="license-user-header-renderer" id={id}>
      <WPHeading
        text={t(displayName)}
        size="small"
        type="default"
        color="var(--du-color-white)"
        className="user-header-text"
        id={`${id}-text`}
      />
      <IconButton
        id="user-sort-button"
        onClick={handleSortClick}
        tooltip={t("ValueStrings.sort")}
        placement="top"
        className="sort-button"
      >
        {sortIcon}
      </IconButton>
    </div>
  );
};

LicenseUserHeaderRenderer.propTypes = {
  displayName: PropTypes.string.isRequired,
  sortDirection: PropTypes.oneOf([
    LICENSE_SORT_DIRECTION.ASC,
    LICENSE_SORT_DIRECTION.DESC,
    null,
  ]),
  onSortClick: PropTypes.func,
  id: PropTypes.string,
};

export default LicenseUserHeaderRenderer;
